import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberFeeForm from '../../../components/forms/MemberFeeForm';
import { useMemberFeeApi } from '../../../hooks/useMemberFeeApi';
import { useNavigate } from 'react-router-dom';
import { MemberFeeDTO } from '../../../services/apiClient';

const MemberFeeCreate: React.FC = () => {
  const { create, isLoading } = useMemberFeeApi();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Member Fees', href: '/admin/memberfees' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: MemberFeeDTO) => {
    try {
      setIsSubmitting(true);
      await create(data);
      navigate('/admin/memberfees');
    } catch (error) {
      console.error('Error creating MemberFee:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/memberfees"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.MemberFee.Edit'
    >
        <MemberFeeForm
          initialValues={{} as MemberFeeDTO}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/memberfees')}
          isLoading={isSubmitting}
        />
    </AdminLayout>
  );
};

export default MemberFeeCreate;